const SERVICES = {
  LIGHT: {
    SERVICE: 'Luz',
    ICON_NAME: 'fa-lightbulb-o'
  },
  WATER: {
    SERVICE: 'Agua',
    ICON_NAME: 'fa-tint'
  },
  MULTIPLE_ACCESSES: {
    SERVICE: 'Múltiples Accesos',
    ICON_NAME: 'fa-columns'
  },
  ELECTRICITY: {
    SERVICE: 'Electricidad',
    ICON_NAME: 'fa-bolt'
  },
  HELMET: {
    SERVICE: 'Casco',
    ICON_NAME: 'fa-home'
  },
  FENCE: {
    SERVICE: 'Alambrado',
    ICON_NAME: 'fa-bars'
  },
  SHED: {
    SERVICE: 'Tinglado',
    ICON_NAME: 'fa-home'
  },
  CONNECTIVITY: {
    SERVICE: 'Conectividad',
    ICON_NAME: 'fa-wifi'
  },
  MANAGER: {
    SERVICE: 'Encargado',
    ICON_NAME: 'fa-user'
  },
  NO_INFORMATION: {
    SERVICE: 'Sin Información',
    ICON_NAME: 'fa-times-circle-o'
  },
  CORRALS: {
    SERVICE: 'Corrales',
    ICON_NAME: 'fa-paw'
  },
  MULTIPLE_PADDOCKS: {
    SERVICE: 'Múltiples Potreros',
    ICON_NAME: 'fa-th-large'
  },
  DEFAULT: {
    ICON_NAME: 'fa-check'
  }
}

module.exports = {
  SERVICES
}